// @mui material components
import Grid from "@mui/material/Grid";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";

// Vision UI Dashboard React components
import MasterCard from "examples/Cards/MasterCard";
// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { emptyPlan, plans, planx } from "const";
import { Card, Divider } from "@mui/material";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import VuiButtonRoot from "components/VuiButton/VuiButtonRoot";
import { useState } from "react";
import { Button, Input, Popover, Spin, message } from "antd";
import { getAuth } from "firebase/auth";
import { ChangeUserPlan } from "Api";
import { sendMailForTransaction } from "utils/Mailer";

export function Plans(){
const [selected, setSelected] = useState(emptyPlan)
const [amount, setAmount] = useState(0)
const [loading, setLoading] = useState(false)


  const content = (
    <div>
      <Input onChange={e => setAmount(e.target.value)} value={amount} min={selected?.min} max={selected?.max} className="mb-2" placeholder="amount to invest" prefix="$" type="number"/>
      <Button disabled={loading} onClick={invest} className="w-100" type="primary">Confirm</Button>
    </div>
  );

  async function invest(){
    const auth = getAuth();
    if (amount > selected?.max) {
      message.error("You can't invest more than the maximum amount")
      return;
    }
    if (amount < selected?.min) {
      message.error("You can't invest less than the minimum amount")
      return;
    }
    setLoading(true)
    try {
      selected.amount = amount;
      await ChangeUserPlan(auth.currentUser.uid, selected)
      await sendMailForTransaction(auth.currentUser.email, auth.currentUser.displayName, amount, "Investment", "Confirmed")
      message.success("Money invested successfully")
    } catch (error) {
      console.log(error)
      message.error("Something went wrong")
    }
    setLoading(false)
  }

    return(
        <DashboardLayout>
          <DashboardNavbar />
          <Spin spinning ={loading}>
          <VuiBox mt={4}  style={{
           minHeight: "65vh"
          }}>
            <VuiBox mb={1.5}>
            <Grid container spacing={3}>
                {planx.map((pl) => (
                   <Grid item xs={12} md={12} xl={4}>
                    <Card style={{ paddingRight: "70px", paddingLeft: "70px", paddingTop: "50px", paddingBottom: "50px"}}>
                    <VuiBox display="flex" flexDirection="column" alignItems="center">
                   <VuiBox mb={1.5}>
                   <VuiTypography  textTransform="capitalize" variant="h3" color={"white"} fontWeight="bold">
                        {pl.name}
                    </VuiTypography>
                   </VuiBox>
                   <VuiBox mb={"30px"}>
                   <VuiTypography  textTransform="capitalize" variant="subtitle1" color={"white"} fontWeight="bold">
                        ${pl.min}
                    </VuiTypography>
                   </VuiBox>
                   <VuiBox>
                   <VuiTypography opacity={0.9}  textTransform="capitalize" variant="caption" color={"white"} fontWeight="bold">
                        Min. Deposit - ${pl.min}
                    </VuiTypography>
                   </VuiBox>
                   <Divider sx={{opacity: 1, width: "100%"}} />
                   <VuiBox>
                   <VuiTypography opacity={0.9}  textTransform="capitalize" variant="caption" color={"white"} fontWeight="bold">
                        Max. Deposit - ${isFinite(pl.max)? pl.max : " Unlimited"}
                    </VuiTypography>
                   </VuiBox>
                   <Divider sx={{opacity: 1, width: "100%"}} />
                   <VuiBox>
                   <VuiTypography opacity={0.9}  textTransform="capitalize" variant="caption" color={"white"} fontWeight="bold">
                       Daily Profit - {pl.Profits / pl.days}%
                    </VuiTypography>
                   </VuiBox>
                   <Divider sx={{opacity: 1, width: "100%"}} />
                   <VuiBox>
                   <VuiTypography opacity={0.9}  textTransform="capitalize" variant="caption" color={"white"} fontWeight="bold">
                       Duration - {pl.days} Days
                    </VuiTypography>
                   </VuiBox>
                   <Divider sx={{opacity: 1, width: "100%"}} />
                   <VuiBox>
                   <VuiTypography opacity={0.9}  textTransform="capitalize" variant="caption" color={"white"} fontWeight="bold">
                       Total Profits - {pl.Profits}%
                    </VuiTypography>
                   </VuiBox>
                   <VuiBox mt={5} sx={{width: "50%"}}>
                    <Popover content={content} trigger={"click"}>
          <VuiButton
          onClick={()=>{
            setSelected(pl)
          }}
            variant="gradient"
            color={"info"}
            fullWidth
          >
            Invest
          </VuiButton>
          </Popover>
        </VuiBox>
                    </VuiBox>
                    </Card>
                    </Grid>
                ))}
           </Grid>
            </VuiBox>
          </VuiBox>
          </Spin>
          </DashboardLayout>)
}